import { DSP, Organization } from '@/common/models';
import { IOrganizationAPI } from '@/common/models/memberships/Organization';
import { IDSPApi } from '@/common/models/misc-api-models/DSP';

export interface IOrganizationDSPApi {
  dsp?: IDSPApi;
  dsp_id: number;
  organization?: IOrganizationAPI;
  organization_dsp_id: number;
  organization_id: number;
  seat_id: string;
}

export default class OrganizationDSP {
  id: number;
  dspId: number;
  organizationId: number;
  seatID: string;
  dsp: DSP;
  organization: Organization;
  name: string;
  exchange?: string;

  constructor(
    id = -1,
    dspId = -1,
    organizationId = -1,
    seatID: string,
    dsp: DSP = null,
    organization: Organization = null,
    exchange: string = null,
  ) {
    this.id = id;
    this.dspId = dspId;
    this.organizationId = organizationId;
    this.seatID = seatID;
    this.dsp = dsp;
    this.organization = organization;
    this.exchange = exchange;

    this.name = `${this.organization.name} - ${this.dsp.name}`;
  }

  get idAndName(): string {
    return `${this.id} - ${this.name}`;
  }

  static fromApi(apiObject: IOrganizationDSPApi): OrganizationDSP {
    return new OrganizationDSP(
      apiObject.organization_dsp_id,
      apiObject.dsp_id,
      apiObject.organization_id,
      apiObject.seat_id,
      DSP.fromApi(apiObject.dsp),
      Organization.fromApi(apiObject.organization),
    );
  }

  toApi(): IOrganizationDSPApi {
    return {
      organization_dsp_id: this.id || undefined,
      dsp_id: this.dspId,
      organization_id: this.organizationId,
      seat_id: this.seatID,
    };
  }
}

export interface OrganizationDSPsOrganization {
  $isDisabled: boolean;

  name: string;
  dsp_name: string;
  seat_id: string;
  exchange_data: {
    modified_on_utc: string;
    archived: boolean;
    exchange_id: number;
    created_on_utc: string;
    suppliers_available_cross_exchange: boolean;
    name: string;
    allowed_subdomain: string;
    ui_domain: string;
    is_white_labeled: boolean;
  };
  currency: string;
  active: boolean;
  organization_dsp_id: number;
  exchange: string;
  is_openrtb: boolean;
  displayName: string;
  id: number;
  seatID: string;
}

export type OrganizationDSPs = OrganizationDSP & {
  dspName: string;
  organizations: OrganizationDSPsOrganization[];
};
